import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface TrailFlagIconProps {
  size?: number;
  color?: string;
  fill?: string;
}

export default function TrailFlagIcon({ size = 16, color = '#C48000', fill = 'none' }: TrailFlagIconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <Path
        d="M5.82224 13.9364L3.67715 3.4173L10.9796 2L10.0468 5.07135L12.0486 7.51027L4.84342 9.03393M2.73047 14H13.271"
        fill={fill}
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
